import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/icons/close.svg'
import _imports_1 from '@/assets/icons/icon-plus.svg'
import _imports_2 from '@/assets/icons/trash.svg'


const _hoisted_1 = { class: "text-semi-bold" }
const _hoisted_2 = { class: "gallery-wr admin-builder-house" }
const _hoisted_3 = { class: "input-row" }
const _hoisted_4 = { class: "input-wr w-100" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_7 = {
  key: 0,
  class: "input-row"
}
const _hoisted_8 = { class: "input-wr w-100" }
const _hoisted_9 = { class: "input-row" }
const _hoisted_10 = { class: "input-wr w-50" }
const _hoisted_11 = ["value", "onChange"]
const _hoisted_12 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_13 = {
  key: 0,
  class: "input-wr w-50"
}
const _hoisted_14 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_15 = {
  key: 0,
  class: "image-remove-wr"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  key: 2,
  class: "upload-image-wr mb-3"
}
const _hoisted_19 = { class: "upload-image-button-wr bigger" }
const _hoisted_20 = {
  key: 0,
  class: "spinner spinner-small"
}
const _hoisted_21 = { class: "input-row" }
const _hoisted_22 = { class: "input-wr w-50" }
const _hoisted_23 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_24 = {
  key: 3,
  class: "room-images-section"
}
const _hoisted_25 = { class: "input-row" }
const _hoisted_26 = { class: "input-wr w-50" }
const _hoisted_27 = { class: "input-wr w-50" }
const _hoisted_28 = { class: "input-row" }
const _hoisted_29 = { class: "input-wr w-50" }
const _hoisted_30 = {
  key: 4,
  class: "included-materials-section"
}
const _hoisted_31 = { class: "included-items-list" }
const _hoisted_32 = { class: "input-wr w-50" }
const _hoisted_33 = ["onUpdate:modelValue"]
const _hoisted_34 = ["value"]
const _hoisted_35 = { class: "input-wr w-50" }
const _hoisted_36 = ["onUpdate:modelValue"]
const _hoisted_37 = { class: "input-wr w-100" }
const _hoisted_38 = ["onUpdate:modelValue"]
const _hoisted_39 = { class: "input-wr w-100" }
const _hoisted_40 = ["onUpdate:modelValue"]
const _hoisted_41 = ["for"]
const _hoisted_42 = ["id", "onChange"]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = { class: "add-more-wrapper" }
const _hoisted_45 = {
  key: 5,
  class: "image-wr facades"
}
const _hoisted_46 = {
  key: 0,
  class: "image-remove-wr"
}
const _hoisted_47 = ["src"]
const _hoisted_48 = {
  key: 1,
  class: "upload-image-wr mb-3"
}
const _hoisted_49 = { class: "upload-image-button-wr bigger" }
const _hoisted_50 = {
  key: 0,
  class: "spinner spinner-small"
}
const _hoisted_51 = { class: "input-row no-margin-top" }
const _hoisted_52 = { class: "input-wr w-50" }
const _hoisted_53 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_54 = {
  key: 6,
  class: "external-color-scheme-section"
}
const _hoisted_55 = { class: "color-schemes-list" }
const _hoisted_56 = { class: "color-scheme-item-header" }
const _hoisted_57 = ["onClick"]
const _hoisted_58 = { class: "input-row" }
const _hoisted_59 = { class: "input-wr w-100" }
const _hoisted_60 = ["placeholder", "onUpdate:modelValue"]
const _hoisted_61 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_62 = { class: "input-row external-color-scheme-price-container" }
const _hoisted_63 = { class: "input-wr w-50 external-color-scheme-price-input" }
const _hoisted_64 = ["value", "onInput"]
const _hoisted_65 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_66 = { class: "image-wr facades" }
const _hoisted_67 = ["onClick"]
const _hoisted_68 = ["src"]
const _hoisted_69 = {
  key: 1,
  class: "upload-image-wr mb-3"
}
const _hoisted_70 = { class: "upload-image-button-wr bigger" }
const _hoisted_71 = ["for"]
const _hoisted_72 = {
  key: 0,
  class: "spinner spinner-small"
}
const _hoisted_73 = { class: "input-wr w-100 position-relative no-margin-top" }
const _hoisted_74 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_75 = ["id", "onChange"]
const _hoisted_76 = {
  key: 0,
  class: "separator"
}
const _hoisted_77 = { class: "add-more-wrapper" }
const _hoisted_78 = {
  key: 7,
  class: "included-items-section"
}
const _hoisted_79 = { class: "included-items-list" }
const _hoisted_80 = { class: "input-wr included-items-section" }
const _hoisted_81 = ["placeholder", "onUpdate:modelValue"]
const _hoisted_82 = ["onClick"]
const _hoisted_83 = { class: "controls" }
const _hoisted_84 = {
  key: 1,
  class: "spinner spinner-small"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode($setup["ModalWithHeader"], {
      isOpen: $props.isOpen,
      maxWidth: true,
      onClose: $setup.close
    }, {
      title: _withCtx(() => [
        _createElementVNode("span", _hoisted_1, _toDisplayString($props.mode === "create" ? "Add" : "Update") + " " + _toDisplayString($setup.props.title) + " " + _toDisplayString($props.asset?.name), 1)
      ]),
      description: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("form", {
            class: "default-form",
            onSubmit: _cache[18] || (_cache[18] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _withDirectives(_createElementVNode("input", {
                  class: "input",
                  placeholder: `${$setup.props.title}'s Name`,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.name) = $event))
                }, null, 8, _hoisted_5), [
                  [_vModelText, $setup.form.name]
                ]),
                ($setup.v$.name.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString($setup.v$.name.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            ($setup.showDescriptionField)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _withDirectives(_createElementVNode("textarea", {
                      class: "input textarea-input",
                      placeholder: "Description",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.description) = $event))
                    }, null, 512), [
                      [_vModelText, $setup.form.description]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("input", {
                  class: "input",
                  placeholder: "Price",
                  value: $setup.form?.price ? $setup.formatPriceTrim($setup.form?.price) : undefined,
                  onChange: (e) => $setup.updatePriceInput(e)
                }, null, 40, _hoisted_11),
                ($setup.v$.price.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString($setup.v$.price.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ]),
              ($setup.props.formType === $setup.AssetGalleryFormType.FACADE)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createVNode($setup["DropDown"], null, {
                      control: _withCtx(() => [
                        _createElementVNode("button", {
                          class: _normalizeClass(["input dropdown-input", { 'input--error': $setup.v$.storeys.$error }]),
                          type: "button"
                        }, _toDisplayString($setup.form.storeys || "Storeys"), 3),
                        ($setup.v$.storeys.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString($setup.v$.storeys.$errors[0].$message), 1))
                          : _createCommentVNode("", true)
                      ]),
                      dropdown: _withCtx(() => [
                        _createElementVNode("ul", null, [
                          (_openBlock(), _createElementBlock("li", {
                            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.form.storeys = 1)),
                            class: _normalizeClass({ 'dropdown__item-active': $setup.form.storeys === 1 }),
                            key: _ctx.storeys
                          }, "1", 2)),
                          (_openBlock(), _createElementBlock("li", {
                            onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.form.storeys = 2)),
                            class: _normalizeClass({ 'dropdown__item-active': $setup.form.storeys === 2 }),
                            key: _ctx.storeys
                          }, "2", 2))
                        ])
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            ($setup.props.formType === $setup.AssetGalleryFormType.INTERNAL_COLOR_SCHEME)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($setup.form.imagesUrls, (imageUrl, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "image-wr facades",
                    key: index
                  }, [
                    ($setup.form.imagesUrls.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          ($setup.form.imagesUrls.length > 0)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "remove-image",
                                onClick: ($event: any) => ($setup.form.imagesUrls = $setup.form.imagesUrls.filter((image) => image !== imageUrl))
                              }, [...(_cache[20] || (_cache[20] = [
                                _createElementVNode("img", {
                                  src: _imports_0,
                                  alt: "close"
                                }, null, -1)
                              ]))], 8, _hoisted_16))
                            : _createCommentVNode("", true),
                          _createElementVNode("img", {
                            class: "facade-upload",
                            src: imageUrl
                          }, null, 8, _hoisted_17)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              : _createCommentVNode("", true),
            ($setup.props.formType === $setup.AssetGalleryFormType.INTERNAL_COLOR_SCHEME)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("label", {
                      class: _normalizeClass(["upload-image-button", { disabled: $setup.isUploadingImage }]),
                      for: 'file-upload'
                    }, [
                      _cache[21] || (_cache[21] = _createElementVNode("img", {
                        src: _imports_1,
                        alt: "uploadImage"
                      }, null, -1)),
                      _cache[22] || (_cache[22] = _createElementVNode("p", null, "Upload image", -1)),
                      ($setup.isUploadingImage)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20))
                        : _createCommentVNode("", true)
                    ], 2)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _cache[23] || (_cache[23] = _createElementVNode("input", { class: "input hidden" }, null, -1)),
                      ($setup.v$.url.$error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString($setup.v$.url.$errors[0].$message), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            ($setup.isInternalColorScheme)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _cache[30] || (_cache[30] = _createElementVNode("h3", { class: "color-schemes-title" }, "Room Images", -1)),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _cache[24] || (_cache[24] = _createElementVNode("label", { class: "label" }, "Living room image URL", -1)),
                      _withDirectives(_createElementVNode("input", {
                        class: "input",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.form.roomImages.livingRoom) = $event)),
                        placeholder: "https://..."
                      }, null, 512), [
                        [_vModelText, $setup.form.roomImages.livingRoom]
                      ]),
                      _cache[25] || (_cache[25] = _createElementVNode("label", {
                        class: "upload-image-button simple-upload",
                        for: 'room-upload-living'
                      }, "Upload image", -1)),
                      _createElementVNode("input", {
                        class: "input-file-upload-image hidden",
                        id: 'room-upload-living',
                        type: "file",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => ($event.target.value = '')),
                        onChange: _cache[6] || (_cache[6] = (e) => $setup.onUploadImage(e, undefined, undefined, { type: 'roomImage', key: 'livingRoom' })),
                        accept: "image/*"
                      }, null, 32)
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _cache[26] || (_cache[26] = _createElementVNode("label", { class: "label" }, "Kitchen image URL", -1)),
                      _withDirectives(_createElementVNode("input", {
                        class: "input",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.form.roomImages.kitchen) = $event)),
                        placeholder: "https://..."
                      }, null, 512), [
                        [_vModelText, $setup.form.roomImages.kitchen]
                      ]),
                      _cache[27] || (_cache[27] = _createElementVNode("label", {
                        class: "upload-image-button simple-upload",
                        for: 'room-upload-kitchen'
                      }, "Upload image", -1)),
                      _createElementVNode("input", {
                        class: "input-file-upload-image hidden",
                        id: 'room-upload-kitchen',
                        type: "file",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => ($event.target.value = '')),
                        onChange: _cache[9] || (_cache[9] = (e) => $setup.onUploadImage(e, undefined, undefined, { type: 'roomImage', key: 'kitchen' })),
                        accept: "image/*"
                      }, null, 32)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _cache[28] || (_cache[28] = _createElementVNode("label", { class: "label" }, "Bathroom image URL", -1)),
                      _withDirectives(_createElementVNode("input", {
                        class: "input",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.form.roomImages.bathroom) = $event)),
                        placeholder: "https://..."
                      }, null, 512), [
                        [_vModelText, $setup.form.roomImages.bathroom]
                      ]),
                      _cache[29] || (_cache[29] = _createElementVNode("label", {
                        class: "upload-image-button simple-upload",
                        for: 'room-upload-bathroom'
                      }, "Upload image", -1)),
                      _createElementVNode("input", {
                        class: "input-file-upload-image hidden",
                        id: 'room-upload-bathroom',
                        type: "file",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => ($event.target.value = '')),
                        onChange: _cache[12] || (_cache[12] = (e) => $setup.onUploadImage(e, undefined, undefined, { type: 'roomImage', key: 'bathroom' })),
                        accept: "image/*"
                      }, null, 32)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            ($setup.isInternalColorScheme)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _cache[38] || (_cache[38] = _createElementVNode("h3", { class: "color-schemes-title" }, "Included Materials", -1)),
                  _createElementVNode("div", _hoisted_31, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.form.includedMaterials, (material, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "input-row",
                        key: index
                      }, [
                        _createElementVNode("div", _hoisted_32, [
                          _cache[32] || (_cache[32] = _createElementVNode("label", { class: "label" }, "Category", -1)),
                          _withDirectives(_createElementVNode("select", {
                            class: "input",
                            "onUpdate:modelValue": ($event: any) => ((material.category) = $event)
                          }, [
                            _cache[31] || (_cache[31] = _createElementVNode("option", { value: null }, "Select category", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.materialCategoryOptions, (option) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: option.value,
                                value: option.value
                              }, _toDisplayString(option.label), 9, _hoisted_34))
                            }), 128))
                          ], 8, _hoisted_33), [
                            [_vModelSelect, material.category]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                          _cache[33] || (_cache[33] = _createElementVNode("label", { class: "label" }, "Name", -1)),
                          _withDirectives(_createElementVNode("input", {
                            class: "input",
                            "onUpdate:modelValue": ($event: any) => ((material.name) = $event),
                            placeholder: "Material name"
                          }, null, 8, _hoisted_36), [
                            [_vModelText, material.name]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_37, [
                          _cache[34] || (_cache[34] = _createElementVNode("label", { class: "label" }, "Details", -1)),
                          _withDirectives(_createElementVNode("input", {
                            class: "input",
                            "onUpdate:modelValue": ($event: any) => ((material.details) = $event),
                            placeholder: "Material details"
                          }, null, 8, _hoisted_38), [
                            [_vModelText, material.details]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_39, [
                          _cache[35] || (_cache[35] = _createElementVNode("label", { class: "label" }, "Swatch image URL", -1)),
                          _withDirectives(_createElementVNode("input", {
                            class: "input",
                            "onUpdate:modelValue": ($event: any) => ((material.swatchImageUrl) = $event),
                            placeholder: "https://..."
                          }, null, 8, _hoisted_40), [
                            [_vModelText, material.swatchImageUrl]
                          ]),
                          _createElementVNode("label", {
                            class: "upload-image-button simple-upload",
                            for: `material-swatch-${index}`
                          }, "Upload swatch", 8, _hoisted_41),
                          _createElementVNode("input", {
                            class: "input-file-upload-image hidden",
                            id: `material-swatch-${index}`,
                            type: "file",
                            onClick: _cache[13] || (_cache[13] = ($event: any) => ($event.target.value = '')),
                            onChange: (e) => $setup.onUploadImage(e, undefined, undefined, { type: 'materialSwatch', index }),
                            accept: "image/*"
                          }, null, 40, _hoisted_42)
                        ]),
                        _createElementVNode("button", {
                          class: "remove-item",
                          onClick: _withModifiers(($event: any) => ($setup.removeIncludedMaterial(index)), ["prevent"])
                        }, [...(_cache[36] || (_cache[36] = [
                          _createElementVNode("img", {
                            src: _imports_0,
                            alt: "remove"
                          }, null, -1)
                        ]))], 8, _hoisted_43)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("button", {
                      class: "add-more",
                      onClick: _withModifiers($setup.addIncludedMaterial, ["prevent"])
                    }, [...(_cache[37] || (_cache[37] = [
                      _createElementVNode("span", { class: "add-more-span" }, "Add Material", -1)
                    ]))])
                  ])
                ]))
              : _createCommentVNode("", true),
            ($setup.props.formType === $setup.AssetGalleryFormType.FACADE || $setup.props.formType === $setup.AssetGalleryFormType.OPTIONAL_UPGRADE)
              ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                  ($setup.form.url)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                        ($setup.form.url)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "remove-image",
                              onClick: _cache[14] || (_cache[14] = ($event: any) => ($setup.form.url = ''))
                            }, [...(_cache[39] || (_cache[39] = [
                              _createElementVNode("img", {
                                src: _imports_0,
                                alt: "close"
                              }, null, -1)
                            ]))]))
                          : _createCommentVNode("", true),
                        _createElementVNode("img", {
                          class: "facade-upload",
                          src: $setup.form.url
                        }, null, 8, _hoisted_47)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_48, [
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("label", {
                            class: _normalizeClass(["upload-image-button", { disabled: $setup.isUploadingImage }]),
                            for: 'file-upload'
                          }, [
                            _cache[40] || (_cache[40] = _createElementVNode("img", {
                              src: _imports_1,
                              alt: "uploadImage"
                            }, null, -1)),
                            _cache[41] || (_cache[41] = _createElementVNode("p", null, "Upload image", -1)),
                            ($setup.isUploadingImage)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_50))
                              : _createCommentVNode("", true)
                          ], 2)
                        ]),
                        _createElementVNode("div", _hoisted_51, [
                          _createElementVNode("div", _hoisted_52, [
                            _cache[42] || (_cache[42] = _createElementVNode("input", { class: "input hidden" }, null, -1)),
                            ($setup.v$.url.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString($setup.v$.url.$errors[0].$message), 1))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("input", {
              class: "input-file-upload-image hidden",
              id: 'file-upload',
              type: "file",
              onClick: _cache[15] || (_cache[15] = ($event: any) => ($event.target.value = '')),
              onChange: _cache[16] || (_cache[16] = ($event: any) => ($setup.onUploadImage($event))),
              accept: "image/*"
            }, null, 32),
            ($setup.props.formType === $setup.AssetGalleryFormType.FACADE)
              ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                  _createElementVNode("div", _hoisted_55, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.form.externalColorSchemes, (scheme, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "color-scheme-item",
                        key: index
                      }, [
                        _createElementVNode("div", _hoisted_56, [
                          _cache[44] || (_cache[44] = _createElementVNode("h3", { class: "color-schemes-title" }, "External Color Schemes", -1)),
                          (index > 0)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "remove-item",
                                onClick: _withModifiers(($event: any) => ($setup.removeColorScheme(index)), ["prevent"])
                              }, [...(_cache[43] || (_cache[43] = [
                                _createElementVNode("img", {
                                  src: _imports_2,
                                  alt: "remove"
                                }, null, -1)
                              ]))], 8, _hoisted_57))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_58, [
                          _createElementVNode("div", _hoisted_59, [
                            _withDirectives(_createElementVNode("input", {
                              class: _normalizeClass(["input", { 'input--error': $setup.colorSchemeErrors[index]?.name }]),
                              placeholder: `Color Scheme Name ${index + 1}`,
                              "onUpdate:modelValue": ($event: any) => ((scheme.name) = $event)
                            }, null, 10, _hoisted_60), [
                              [_vModelText, scheme.name]
                            ]),
                            ($setup.colorSchemeErrors[index]?.name)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_61, "Color scheme name is required"))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_62, [
                            _createElementVNode("div", _hoisted_63, [
                              _createElementVNode("input", {
                                class: _normalizeClass(["input", { 'input--error': $setup.colorSchemeErrors[index]?.price }]),
                                placeholder: "Price",
                                value: scheme?.price ? $setup.formatPriceTrim(scheme?.price) : undefined,
                                onInput: (e) => $setup.updatePriceInput(e, scheme)
                              }, null, 42, _hoisted_64),
                              ($setup.colorSchemeErrors[index]?.price)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_65, "Color scheme price is required"))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_66, [
                          (scheme.imagesUrls.length > 0)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(scheme.imagesUrls, (imageUrl, imgIndex) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "image-remove-wr",
                                  key: imgIndex
                                }, [
                                  _createElementVNode("div", {
                                    class: "remove-image",
                                    onClick: ($event: any) => (scheme.imagesUrls = scheme.imagesUrls.filter((_, i) => i !== imgIndex))
                                  }, [...(_cache[45] || (_cache[45] = [
                                    _createElementVNode("img", {
                                      src: _imports_0,
                                      alt: "close"
                                    }, null, -1)
                                  ]))], 8, _hoisted_67),
                                  _createElementVNode("img", {
                                    class: "facade-upload",
                                    src: imageUrl
                                  }, null, 8, _hoisted_68)
                                ]))
                              }), 128))
                            : (_openBlock(), _createElementBlock("div", _hoisted_69, [
                                _createElementVNode("div", _hoisted_70, [
                                  _createElementVNode("label", {
                                    class: _normalizeClass(["upload-image-button", { disabled: $setup.isUploadingImage, 'error-border': $setup.colorSchemeErrors[index]?.imagesUrls }]),
                                    for: `file-upload-scheme-${index}`
                                  }, [
                                    _cache[46] || (_cache[46] = _createElementVNode("img", {
                                      src: _imports_1,
                                      alt: "uploadImage"
                                    }, null, -1)),
                                    _cache[47] || (_cache[47] = _createElementVNode("p", null, "Upload image", -1)),
                                    ($setup.isUploadingImage && $setup.currentUploadingSchemeIndex === index)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_72))
                                      : _createCommentVNode("", true)
                                  ], 10, _hoisted_71)
                                ]),
                                _createElementVNode("div", _hoisted_73, [
                                  ($setup.colorSchemeErrors[index]?.imagesUrls)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_74, "Color scheme image is required"))
                                    : _createCommentVNode("", true)
                                ])
                              ])),
                          _createElementVNode("input", {
                            class: "input-file-upload-image hidden",
                            id: `file-upload-scheme-${index}`,
                            type: "file",
                            onClick: _cache[17] || (_cache[17] = ($event: any) => ($event.target.value = '')),
                            onChange: (e) => $setup.onUploadImage(e, index, scheme),
                            accept: "image/*"
                          }, null, 40, _hoisted_75)
                        ]),
                        (index < $setup.form.externalColorSchemes.length - 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_76))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_77, [
                    _createElementVNode("button", {
                      class: "add-more",
                      onClick: _withModifiers($setup.addColorScheme, ["prevent"])
                    }, [...(_cache[48] || (_cache[48] = [
                      _createElementVNode("span", { class: "add-more-span" }, "Add Color Scheme", -1)
                    ]))])
                  ])
                ]))
              : _createCommentVNode("", true),
            ($setup.hasIncludedItems)
              ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                  _cache[51] || (_cache[51] = _createElementVNode("h3", { class: "whats-included-title" }, "What's Included?", -1)),
                  _createElementVNode("div", _hoisted_79, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.form.includedItems, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "input-row",
                        key: index
                      }, [
                        _createElementVNode("div", _hoisted_80, [
                          _withDirectives(_createElementVNode("input", {
                            class: "input",
                            placeholder: 'Item ' + (index + 1),
                            "onUpdate:modelValue": ($event: any) => (($setup.form.includedItems[index]) = $event)
                          }, null, 8, _hoisted_81), [
                            [_vModelText, $setup.form.includedItems[index]]
                          ]),
                          (index > 0)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "remove-item",
                                onClick: _withModifiers(($event: any) => ($setup.removeItem(index)), ["prevent"])
                              }, [...(_cache[49] || (_cache[49] = [
                                _createElementVNode("img", {
                                  src: _imports_0,
                                  alt: "remove"
                                }, null, -1)
                              ]))], 8, _hoisted_82))
                            : _createCommentVNode("", true),
                          (index === 0)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "add-more",
                                onClick: _withModifiers($setup.addItem, ["prevent"])
                              }, [...(_cache[50] || (_cache[50] = [
                                _createElementVNode("span", { class: "add-more-span" }, "Add More", -1)
                              ]))]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 32),
          _createElementVNode("div", _hoisted_83, [
            _createElementVNode("button", {
              class: "button p-2 cancel",
              onClick: $setup.close
            }, "Cancel"),
            (!$setup.isLoading)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "button p-2 primary mr-0",
                  onClick: $setup.confirm
                }, "Confirm"))
              : (_openBlock(), _createElementBlock("div", _hoisted_84))
          ])
        ])
      ]),
      _: 1
    }, 8, ["isOpen"]),
    _createVNode($setup["ImageCropperModal"], {
      isOpen: $setup.isCropperModalOpen,
      image: $setup.imageToUpload.data,
      onOnCropImage: $setup.onCropImage,
      onClose: _cache[19] || (_cache[19] = ($event: any) => ($setup.isCropperModalOpen = false))
    }, null, 8, ["isOpen", "image"])
  ], 64))
}